import { AppBar, Box, Button, Link, Toolbar } from '@mui/material';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link as RouterLink, RouteComponentProps } from 'react-router-dom';

import { User } from 'app/model/user';
import { RootState } from 'app/store';
import { TaxonomyChooser } from 'features/auth/taxonomy-chooser';

import { AppBreadCrumbs } from './app-bread-crumbs';
import { AuxMenu } from './aux-menu';
import styles from './header.module.scss';
import { HelpMenu } from './help-menu';
import { TopNav } from './top-nav';
import { logoutUser, selectLoggedIn, selectProfile } from '../auth/auth.slice';

interface HeaderProps {
    loggedIn: boolean;
    profile?: User;

    logoutUser: () => void;
}

interface HeaderState {
    topNavVal: number;
}

class Header extends React.Component<HeaderProps & RouteComponentProps, HeaderState> {
    public constructor(props: Readonly<HeaderProps & RouteComponentProps> | (HeaderProps & RouteComponentProps)) {
        super(props);

        this.state = {
            topNavVal: 0,
        };
    }

    public render() {
        const logoutBtn = (
            <Button
                color='inherit'
                onClick={() => {
                    this.props.logoutUser();
                    this.props.history.push('/');
                }}
            >
                Logout {this.parseUsername()}
            </Button>
        );
        const loginBtn = (
            <Button
                color='inherit'
                onClick={() => {
                    this.props.history.push('/login');
                }}
            >
                Login
            </Button>
        );

        return (
            <div className={styles.header}>
                <AppBar position='static' className={styles.appBar}>
                    <Toolbar>
                        <Link component={RouterLink} to='/' color='inherit' variant='h5' underline='hover'>
                            Analog
                        </Link>
                        <TaxonomyChooser compact />
                        <Box mx='1em'>
                            <TopNav />
                        </Box>
                        {/* <Box width='30em'><input type='text' style={{width: '100%'}}/></Box>*/}
                        <Box flexGrow={1} />
                        <HelpMenu />
                        <AuxMenu />
                        {this.props.loggedIn ? logoutBtn : loginBtn}
                    </Toolbar>
                </AppBar>
                <AppBreadCrumbs />
            </div>
        );
    }

    private parseUsername() {
        if (!this.props.profile) {
            return '';
        }

        return this.props.profile.username.split('@')[0];
    }
}

const mapStateToProps = (state: RootState) => ({
    loggedIn: selectLoggedIn(state),
    profile: selectProfile(state),
});

const HeaderWithRouter = connect(mapStateToProps, { logoutUser })(withRouter(Header));

export { HeaderWithRouter as Header };
